module.exports = __webpack_public_path__ + "img/delivery_title.a1ce60b5.svg";